
import React, { useEffect, useState } from "react";

// reactstrap components
import {
    UncontrolledAlert,
    Button,
    Card,
    CardHeader,
    Table,
    Container,
    Row,
    Col,
    UncontrolledTooltip,
    Modal,
    CardBody,
    Form,
    FormGroup,
    Input,
    ModalBody,
    ModalHeader,
    Label,
    // Pagination, PaginationItem, PaginationLink,
    Spinner,
    Alert,
    InputGroupText,
    InputGroup,
    InputGroupAddon,
} from "reactstrap";
// import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'

// core components
import SimpleHeader from "components/Headers/SimpleHeader.js";
import { getAllInvoices, deleteInvoice, updateInvoice, sendPaymentLink } from "api/invoiceApiCall";
import { useNavigate } from 'react-router-dom';
import InvoiceReceipt from "./InvoiceReceipt";
import ReactDOMServer from 'react-dom/server';
import Swal from 'sweetalert2'
import { sendReceipt } from "api/invoiceApiCall";
import { Loader } from "lucide-react";
import { getUserLogo } from "api/authApiCall";
// import { updatePaymentStatus } from "api/invoiceApiCall";
import { useTranslation } from '../../../i18n/context';


function Invoice() {
    const [allInvoices, setAllInvoices] = useState([]);
    const [filteredInvoices, setFilteredInvoices] = useState([]);
    const [allInvoicesError, setAllInvoicesError] = useState({});
    const [formModal, setFormModal] = React.useState(false);
    const [paymentFormModal, setPaymentFormModal] = React.useState(false);
    const [paymentReceiptModal, setPaymentReceiptModal] = React.useState(false);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showErrorAlert, setShowErrorAlert] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const [selectedInvoice, setSelectedInvoice] = useState({});
    const [tooltipIds, setTooltipIds] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    const [loadingStates, setLoadingStates] = useState({});
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [isDateFilterActive, setIsDateFilterActive] = useState(false);
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [isLoadingInvoices, setIsLoadingInvoices] = useState(false);



    useEffect(() => {
        if (Array.isArray(allInvoices)) {
            const ids = allInvoices.map((_, index) => ({
                edit: `tooltipEdit${index}`,
                delete: `tooltipDelete${index}`,
                print: `tooltipPrint${index}`,
                payment: `tooltipPayment${index}`,
                receipt: `tooltipReceipt${index}`,
            }));
            setTooltipIds(ids);
        } else {
            console.warn('allInvoices is not an array:', allInvoices);
        }
    }, [allInvoices]);

    useEffect(() => {
        let results = allInvoices;

        // Filter by customer name if search term exists
        if (searchTerm) {
            results = results.filter(invoice =>
                invoice.customer_name.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        // Apply date filter if active
        if (isDateFilterActive && startDate && endDate) {
            const startDateTime = new Date(startDate).setHours(0, 0, 0, 0);
            const endDateTime = new Date(endDate).setHours(23, 59, 59, 999);

            results = results.filter(invoice => {
                const invoiceDate = new Date(invoice.invoice_date).getTime();
                return invoiceDate >= startDateTime && invoiceDate <= endDateTime;
            });
        }

        setFilteredInvoices(results);
        setCurrentPage(1);
    }, [searchTerm, allInvoices, startDate, endDate, isDateFilterActive]);


    const applyDateFilter = () => {
        setIsDateFilterActive(true);
    };

    // Add handler for clearing date filter
    const clearDateFilter = () => {
        setStartDate('');
        setEndDate('');
        setIsDateFilterActive(false);
    };


    const toggleModal = () => {
        setFormModal(!formModal);
    };


    {
        isLoadingInvoices && (
            <div className="text-center p-5">
                <Spinner /> Loading invoices...
            </div>
        )
    }


    const paymentToggleModal = () => {
        setPaymentFormModal(!paymentFormModal);
    };

    const receiptToggleModal = () => {
        setPaymentReceiptModal(!paymentReceiptModal);
    };

    const handleEditClick = (invoiceData) => {
        setSelectedInvoice(invoiceData);
        toggleModal();
    };

    

    const handlePaymentLink = (invoiceData) => {
        setSelectedInvoice(invoiceData);
        paymentToggleModal();
    };

    const handleReceipt = (invoiceData) => {
        setSelectedInvoice(invoiceData);
        receiptToggleModal();
    };

    const calculateSubtotal = (products) => {
        return products.reduce((total, product) => {
            return total + (parseFloat(product.price) || 0) * (parseFloat(product.quantity) || 0);
        }, 0) - (parseFloat(selectedInvoice.discount) || 0);
    };

    useEffect(() => {
        if (selectedInvoice.invoice_date) {
            const formattedDate = formatDate(selectedInvoice.invoice_date);
            setSelectedInvoice(prev => ({ ...prev, invoice_date: formattedDate }));
        }
    }, [selectedInvoice._id]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toISOString().split('T')[0];
    };

    const handleDateChange = (e) => {
        setSelectedInvoice({ ...selectedInvoice, invoice_date: e.target.value });
    };

    const handleProductChange = (index, field, value) => {
        const updatedProducts = [...selectedInvoice.products];
        updatedProducts[index] = { ...updatedProducts[index], [field]: value };
        setSelectedInvoice({ ...selectedInvoice, products: updatedProducts, subtotal: calculateSubtotal(updatedProducts) });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const [errorInvoicesCall, successUserCall] = await updateInvoice(selectedInvoice);
            if (errorInvoicesCall) {
                setErrorMessages(errorInvoicesCall.message);
                setShowErrorAlert(true);
            } else {
                setShowSuccessAlert(true);
                window.location.reload();
            }
        } catch (error) {
            setErrorMessages([error.message]);
            setShowErrorAlert(true);
        }
    };


    const handleCopyPaymentLink = async (invoice) => {
  const [err, data] = await sendPaymentLink(invoice);

  if (err) {
    alert("Failed to generate link");
    return;
  }

  navigator.clipboard.writeText(data.paymentLink);
  alert("Payment link copied!");
};



    const handleDeleteClick = (invoiceId) => {
        Swal.fire({
            title: t('category.sure'),
            text: t('category.delete_text'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('category.delete_confirm')
        }).then((result) => {
            if (result.isConfirmed) {
                deleteInvoice(invoiceId)
                    .then(([error, successData]) => {
                        if (error) {
                            Swal.fire(
                                t('common.error'),
                                error.message || t('invoice.not_successfull'),
                                'error'
                            );
                        } else {
                            Swal.fire(
                                t('profile.delete_success_title'),
                                t('invoice.deleted'),
                                'success'
                            ).then(() => {
                                window.location.reload();
                            });
                        }
                    })
                    .catch(error => {
                        Swal.fire(
                            t('common.error'),
                            t('category.delete_error_title'),
                            'error'
                        );
                    });
            }
        });
    };


    const handlePaymentSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const [errorPaymentLink, successPaymentLink] = await sendPaymentLink({
                ...selectedInvoice,
                customer_phone: selectedInvoice.customer_phone,
                country_code: selectedInvoice.country_code || '',
            });

            if (errorPaymentLink) {
                setErrorMessages([errorPaymentLink.message]);
                setShowErrorAlert(true);
            } else {
                setShowSuccessAlert(true);
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            }
        } catch (error) {
            setErrorMessages([error.message]);
            setShowErrorAlert(true);
        } finally {
            setIsLoading(false);
        }
    };

    const handleReceiptSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const [errorPaymentReceipt, successPaymentReceipt] = await sendReceipt(selectedInvoice);
            if (errorPaymentReceipt) {
                setErrorMessages([errorPaymentReceipt.message]);
                setShowErrorAlert(true);
            } else {
                setShowSuccessAlert(true);
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            }
        } catch (error) {
            setErrorMessages([error.message]);
            setShowErrorAlert(true);
        } finally {
            setIsLoading(false);
        }
    };

    const handleInvoicesCall = async (pageNum = 1) => {
        setIsLoadingInvoices(true);
        const [error, res] = await getAllInvoices(pageNum);

        if (error) {
            setAllInvoicesError(error);
        } else {
            setAllInvoices(res.data);
            setTotalPages(res.pagination.totalPages);
        }

        setIsLoadingInvoices(false);
    };


    useEffect(() => {
        handleInvoicesCall(page);
    }, [page]);


    useEffect(() => {
        const timeOutError = setTimeout(() => {
            setAllInvoicesError({});
        }, 10000)
        return () => {
            clearTimeout(timeOutError);
        }
    }, [allInvoicesError])

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredInvoices.slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNum) => {
        setPage(pageNum);
    };



    //Print
    const handlePrintInvoice = (invoiceData) => {
        const logoUrl = getUserLogo();
        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
            <html>
                <head>
                    <title>${invoiceData.customer_name}'s invoice</title>
                     <link rel="icon" href="/public/White (1).png" type="image/x-icon">
                    <style>
                     @media print {
                        @page {
                            margin: 0;
                        }
                        body {
                            margin: 1.6cm;
                        }
                        /* Hide the URL */
                        @page :first {
                            margin-top: 0;
                        }
                    }
                       .invoice-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: __Inter_d65c78,__Inter_Fallback_d65c78
}

.invoice-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 30px;
}

.company-name {
  color: #4d67fd;
  font-size: 1.5em;
  margin: 0;
}

.invoice-info {
  text-align: right;
}

.address-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}

.invoice-items {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 30px;
}

.invoice-items th, .invoice-items td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: left;
}

.invoice-items th {
  background-color: #f2f2f2;
}

.invoice-summary {
  width: 300px;
  margin-left: auto;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.total {
  font-weight: bold;
  border-top: 1px solid #ddd;
  padding-top: 10px;
}

.thank-you {
  margin-top: 30px;
  color: #888;
}

footer {
  margin-top: 50px;
  text-align: center;
  color: #888;
}
                    </style>
                </head>
                <body>
                    ${ReactDOMServer.renderToString(<InvoiceReceipt invoice={invoiceData} logoUrl={logoUrl} />)}
                </body>
            </html>
        `);
        printWindow.document.close();

        printWindow.onload = () => {
            printWindow.focus();
            printWindow.print();
            printWindow.onafterprint = () => printWindow.close();
        };
    };

    return (
        <>
            <SimpleHeader name={t('invoice.invoices')} parentName={t('invoice.invoices')} />
            <Container className="mt--6" fluid>
                <Card>
                    <CardHeader className="border-0">
                        <Row>
                            <Col xs="6">
                                <h3 className="mb-0">{t('invoice.management')}</h3>
                            </Col>
                            <Col className="text-right" xs="6">
                                <Button
                                    className="btn-round btn-icon"
                                    color="primary"
                                    id="tooltip443412080"
                                    onClick={() => navigate('/admin/addinvoices')}
                                    size="sm"
                                >
                                    <span className="btn-inner--icon mr-1">
                                        <i className="fas fa-user-edit" />
                                    </span>
                                    <span className="btn-inner--text">{t('invoice.add_invoice')}</span>
                                </Button>
                                <UncontrolledTooltip delay={0} target="tooltip443412080">
                                    {t('invoice.add_invoice')}
                                </UncontrolledTooltip>
                            </Col>
                        </Row>
                    </CardHeader>
                    {showSuccess && (
                        <Alert color="success" isOpen={showSuccess} toggle={() => setShowSuccessAlert(false)}>
                            {t('invoice.payment_success')}
                        </Alert>
                    )}

                    {showError && (
                        <UncontrolledAlert color="danger">
                            <span className="alert-text ml-1">
                                <strong>{t('profile.error')}!</strong> {t('invoice.not_updated')}
                            </span>
                        </UncontrolledAlert>
                    )}

                    <div className="px-3 py-2">
                        <Row>
                            <Col md="6">
                                <Input
                                    type="text"
                                    placeholder={t('invoice.search')}
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                />
                            </Col>
                            <Col md="6">
                                <Row>
                                    <Col md="4">
                                        <FormGroup>
                                            <Input
                                                type="date"
                                                placeholder="Start Date"
                                                value={startDate}
                                                onChange={(e) => setStartDate(e.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                        <FormGroup>
                                            <Input
                                                type="date"
                                                placeholder="End Date"
                                                value={endDate}
                                                onChange={(e) => setEndDate(e.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                        <FormGroup className="d-flex">
                                            <Button
                                                color="primary"
                                                size="sm"
                                                onClick={applyDateFilter}
                                                className="mr-2"
                                                disabled={!startDate || !endDate}
                                            >
                                                <i className="fas fa-filter mr-1"></i>
                                                {t('invoice.filter')}
                                            </Button>
                                            {isDateFilterActive && (
                                                <Button
                                                    color="secondary"
                                                    size="sm"
                                                    onClick={clearDateFilter}
                                                >
                                                    <i className="fas fa-times mr-1"></i>
                                                    {t('invoice.clear')}
                                                </Button>
                                            )}
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>

                    {allInvoices && allInvoices.length > 0 && (
                        <Table className="align-items-center table-flush" responsive striped>
                            <thead className="thead-light">
                                <tr>
                                    <th>{t('invoice.customer_name')}</th>
                                    <th> {t('invoice.customer_country')}</th>
                                    <th> {t('invoice.customer_address')}</th>
                                    <th>{t('invoice.customer_email')}</th>
                                    <th>{t('invoice.customer_phone')}</th>
                                    <th> {t('invoice.invoice_date')}</th>
                                    <th> {t('invoice.customer_product_name')}</th>
                                    <th> {t('invoice.quantity')}</th>
                                    <th>{t('invoice.price')}</th>
                                    <th> {t('invoice.discount')}</th>
                                    <th>{t('invoice.subtotal')}</th>
                                    {/* {isAdmin && <th>Payout </th>} */}
                                    <th>{t('invoice.status')}</th>
                                    <th>Action</th>
                                    <th />
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems
                                    .sort((a, b) => new Date(b.invoice_date) - new Date(a.invoice_date))
                                    .map((invoiceData, index) => (
                                        <tr key={index}>
                                            <td>{invoiceData?.customer_name}</td>
                                            <td>{invoiceData?.customer_country}</td>
                                            <td>{invoiceData?.customer_address}</td>
                                            <td>{invoiceData?.customer_email}</td>
                                            <td>{invoiceData?.customer_phone}</td>
                                            <td>{new Date(invoiceData?.invoice_date).toLocaleDateString()}</td>

                                            <td>
                                                {invoiceData?.products?.map((product, prodIndex) => (
                                                    <div key={prodIndex}>{product.product_name}</div>
                                                ))}
                                            </td>
                                            <td>
                                                {invoiceData?.products?.map((product, prodIndex) => (
                                                    <div key={prodIndex}>{product.quantity}</div>
                                                ))}
                                            </td>
                                            <td>
                                                {invoiceData?.products?.map((product, prodIndex) => (
                                                    <div key={prodIndex}>
                                                        {product.currency ? `${product.currency} ${product.price}` : product.price}
                                                    </div>
                                                ))}
                                            </td>

                                            <td>{invoiceData?.discount}</td>

                                            <td>
                                                {Number(invoiceData.subtotal).toFixed(2).replace(/\.00$/, '')}
                                            </td>
                                            {/* {isAdmin && <td>{invoiceData?.payout_number}</td>} */}
                                            <td>
                                                <Button
                                                    color={invoiceData?.paymentStatus ? "success" : "warning"}
                                                    size="sm"
                                                    // onClick={() => handlePaymentStatusToggle(invoiceData)}
                                                    disabled={loadingStates[invoiceData._id]}
                                                >
                                                    {loadingStates[invoiceData._id] ? (
                                                        <Spinner size="sm" />
                                                    ) : (
                                                        invoiceData?.paymentStatus ? t('invoice.paid') : t('invoice.not_paid')
                                                    )}
                                                </Button>
                                            </td>
                                            <td className="table-actions">
                                                <a
                                                    className="table-action"
                                                    href="#pablo"
                                                    id={tooltipIds[index]?.edit}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleEditClick(invoiceData);
                                                    }}
                                                >
                                                    <i className="fas fa-user-edit" />
                                                </a>
                                                {tooltipIds[index] && (
                                                    <UncontrolledTooltip delay={0} target={tooltipIds[index].edit}>
                                                        {t('invoice.edit_invoice')}
                                                    </UncontrolledTooltip>
                                                )}
                                                <a
                                                    className="table-action"
                                                    id={tooltipIds[index]?.print}
                                                    onClick={() => handlePrintInvoice(invoiceData)}
                                                >
                                                    <i className="fas fa-print" />
                                                </a>
                                                {tooltipIds[index] && (
                                                    <UncontrolledTooltip delay={0} target={tooltipIds[index].print}>
                                                        {t('invoice.print_invoice')}
                                                    </UncontrolledTooltip>
                                                )}
                                                <a
                                                    className="table-action table-action-delete"
                                                    href="#pablo"
                                                    id={tooltipIds[index]?.payment}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handlePaymentLink(invoiceData);
                                                    }}
                                                >
                                                    <i className="fas fa-credit-card" />
                                                </a>
                                                {tooltipIds[index] && (
                                                    <UncontrolledTooltip delay={0} target={tooltipIds[index].payment}>
                                                        {t('invoice.payment_link')}
                                                    </UncontrolledTooltip>
                                                )}
                                                <a
                                                    className="table-action table-action-delete"
                                                    href="#pablo"
                                                    id={tooltipIds[index]?.receipt}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleReceipt(invoiceData);
                                                    }}
                                                >
                                                    <i className="fas fa-receipt" />
                                                </a>
                                                {tooltipIds[index] && (
                                                    <UncontrolledTooltip delay={0} target={tooltipIds[index].receipt}>
                                                        {t('invoice.send_receipt')}
                                                    </UncontrolledTooltip>
                                                )}
                                                <a
                                                    className="table-action table-action-delete"
                                                    href="#pablo"
                                                    id={tooltipIds[index]?.delete}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleDeleteClick(invoiceData._id);
                                                    }}
                                                >
                                                    <i className="fas fa-trash" />
                                                </a>
                                                {tooltipIds[index] && (
                                                    <UncontrolledTooltip delay={0} target={tooltipIds[index].delete}>
                                                        {t('invoice.delete_invoice')}
                                                    </UncontrolledTooltip>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </Table>
                    )
                    }

                    <div className="card-footer py-4">
                        <nav>
                            <ul className="pagination justify-content-center flex-wrap">
                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => paginate(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                        <i className="fas fa-angle-left" />
                                    </button>
                                </li>

                                {/* Dynamic page number display based on screen size */}
                                {[...Array(Math.ceil(filteredInvoices.length / itemsPerPage))].map((_, index) => {
                                    // For mobile, show limited pagination numbers
                                    const pageNum = index + 1;

                                    // Only show: current page, first page, last page, and one page before/after current
                                    const isCurrentPage = pageNum === currentPage;
                                    const isFirstPage = pageNum === 1;
                                    const isLastPage = pageNum === Math.ceil(filteredInvoices.length / itemsPerPage);
                                    const isBeforeCurrentPage = pageNum === currentPage - 1;
                                    const isAfterCurrentPage = pageNum === currentPage + 1;

                                    // Show if it meets our display criteria
                                    const shouldDisplay = isCurrentPage || isFirstPage || isLastPage ||
                                        isBeforeCurrentPage || isAfterCurrentPage;

                                    // Add ellipsis indicators
                                    const showEllipsisBefore = pageNum === currentPage - 1 && currentPage > 3;
                                    const showEllipsisAfter = pageNum === currentPage + 1 &&
                                        currentPage < Math.ceil(filteredInvoices.length / itemsPerPage) - 2;

                                    return shouldDisplay ? (
                                        <React.Fragment key={index}>
                                            {showEllipsisBefore && (
                                                <li className="page-item disabled">
                                                    <span className="page-link">...</span>
                                                </li>
                                            )}

                                            <li className={`page-item ${isCurrentPage ? 'active' : ''}`}>
                                                <button
                                                    className="page-link"
                                                    onClick={() => paginate(pageNum)}
                                                >
                                                    {pageNum}
                                                </button>
                                            </li>

                                            {showEllipsisAfter && (
                                                <li className="page-item disabled">
                                                    <span className="page-link">...</span>
                                                </li>
                                            )}
                                        </React.Fragment>
                                    ) : null;
                                })}

                                <li className={`page-item ${currentPage === Math.ceil(filteredInvoices.length / itemsPerPage) ? 'disabled' : ''}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => paginate(currentPage + 1)}
                                        disabled={currentPage === Math.ceil(filteredInvoices.length / itemsPerPage)}
                                    >
                                        <i className="fas fa-angle-right" />
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </Card>
            </Container>

            <Modal className="modal-dialog-centered" size="sm" isOpen={formModal} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>{t('invoice.edit_invoice')}</ModalHeader>
                <ModalBody>
                    <Card className="bg-secondary border-0 mb-0">
                        <CardBody className="">
                            <div className="text-center text-muted mb-4">
                                <small>{t('invoice.edit_invoice_details')}</small>
                                {showSuccessAlert && (
                                    <UncontrolledAlert color="success">
                                        <span className="alert-text ml-1">
                                            <strong>{t('profile.success')}</strong> {t('invoice.updated')}
                                        </span>
                                    </UncontrolledAlert>
                                )}
                                {showErrorAlert && (
                                    <UncontrolledAlert color="danger">
                                        <span className="alert-text ml-1">
                                            <strong>{t('profile.error')}</strong> {t('invoice.not_updatedd')}
                                        </span>
                                    </UncontrolledAlert>
                                )}
                            </div>
                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <Label className="form-control-label" md="4">{t('invoice.customer_name')}</Label>
                                    <Col md="8">
                                        <FormGroup>
                                            <Input
                                                placeholder={t('invoice.customer_name')}
                                                type="text"
                                                value={selectedInvoice.customer_name || ''}
                                                onChange={(e) => setSelectedInvoice({ ...selectedInvoice, customer_name: e.target.value })}
                                                required
                                                readOnly
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Label className="form-control-label" md="4">{t('customer.address')}</Label>
                                    <Col md="8">
                                        <FormGroup>
                                            <Input
                                                placeholder={t('customer.address')}
                                                type="text"
                                                value={selectedInvoice.customer_address || ''}
                                                onChange={(e) => setSelectedInvoice({ ...selectedInvoice, customer_address: e.target.value })}
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Label className="form-control-label" md="4">Email</Label>
                                    <Col md="8">
                                        <FormGroup>
                                            <Input
                                                placeholder="Email"
                                                type="text"
                                                value={selectedInvoice.customer_email || ''}
                                                onChange={(e) => setSelectedInvoice({ ...selectedInvoice, customer_email: e.target.value })}
                                                required
                                                readOnly
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Label className="form-control-label" md="4">{t('invoice.invoice_date')}</Label>
                                    <Col md="8">
                                        <FormGroup>
                                            <Input
                                                placeholder="Date"
                                                type="date"
                                                name="invoice-date"
                                                id="invoice-date"
                                                value={selectedInvoice.invoice_date || ''}
                                                onChange={handleDateChange}
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Label className="form-control-label" md="4">{t('invoice.discount')}</Label>
                                    <Col md="8">
                                        <FormGroup>
                                            <Input
                                                placeholder="Discount"
                                                type="text"
                                                readOnly
                                                value={selectedInvoice.discount || ''}
                                                onChange={(e) => setSelectedInvoice({ ...selectedInvoice, discount: e.target.value })}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>

                                {selectedInvoice.products && selectedInvoice.products.map((product, index) => (
                                    <div key={index}>
                                        <Row>
                                            <Label className="form-control-label" md="4" for={`product-name-${index}`}>{t('invoice.customer_product_name')}</Label>
                                            <Col md="8">
                                                <FormGroup>
                                                    <Input
                                                        type="text"
                                                        name={`product-name-${index}`}
                                                        id={`product-name-${index}`}
                                                        value={product.product_name || ''}
                                                        onChange={(e) => handleProductChange(index, 'product_name', e.target.value)}
                                                        required
                                                        readOnly
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Label className="form-control-label" md="4" for={`quantity-${index}`}>{t('invoice.quantity')}</Label>
                                            <Col md="8">
                                                <FormGroup>
                                                    <Input
                                                        placeholder="Quantity"
                                                        type="number"
                                                        name={`quantity-${index}`}
                                                        id={`quantity-${index}`}
                                                        value={product.quantity || ''}
                                                        onChange={(e) => handleProductChange(index, 'quantity', e.target.value)}
                                                        required
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Label className="form-control-label" md="4" for={`price-${index}`}>{t('invoice.price')}</Label>
                                            <Col md="8">
                                                <FormGroup>
                                                    <Input
                                                        placeholder="Price"
                                                        type="number"
                                                        name={`price-${index}`}
                                                        id={`price-${index}`}
                                                        value={product.price || ''}
                                                        onChange={(e) => handleProductChange(index, 'price', e.target.value)}
                                                        required
                                                        readOnly
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                ))}


                                <Row>
                                    <Label className="form-control-label" md="4">{t('invoice.subtotal')}</Label>
                                    <Col md="8">
                                        <FormGroup>
                                            <Input
                                                placeholder="Subtotal"
                                                type="text"
                                                name="subtotal"
                                                id="subtotal"
                                                value={selectedInvoice.subtotal || ''}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Button color="primary" type="submit">{t('profile.submit')}</Button>
                                <Button color="secondary" onClick={toggleModal}>{t('profile.cancel')}</Button>
                            </Form>
                        </CardBody>
                    </Card>
                </ModalBody>
            </Modal>

            {/* //Payment Link Modal */}
            <Modal className="modal-dialog-centered" size="sm" isOpen={paymentFormModal} toggle={paymentToggleModal}>
                <ModalHeader toggle={paymentToggleModal}>{t('invoice.payment_link')}</ModalHeader>
                <ModalBody>
                    <Card className="bg-secondary border-0 mb-0">
                        <CardBody className="">
                            <div className="text-center text-muted mb-4">
                                {showSuccessAlert && (
                                    <UncontrolledAlert color="success">

                                        <span className="alert-text ml-1">
                                            <strong>{t('profile.success')}</strong> {t('invoice.link_sent')}
                                        </span>
                                    </UncontrolledAlert>
                                )}
                                {showErrorAlert && (
                                    <UncontrolledAlert color="danger">
                                        <span className="alert-text ml-1">
                                            <strong>{t('profile.error')}</strong> {t('invoice.link_not__sent')}
                                        </span>
                                    </UncontrolledAlert>
                                )}
                            </div>
                            <Form onSubmit={handlePaymentSubmit}>
                                <Row>
                                    <Label className="form-control-label" md="4">{t('invoice.to')}</Label>
                                    <Col md="8">
                                        <FormGroup>
                                            <Input
                                                placeholder="Customer name"
                                                type="text"
                                                value={selectedInvoice.customer_name || ''}
                                                readOnly
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Label className="form-control-label" md="4">{t('customer.country')}</Label>
                                    <Col md="8">
                                        <FormGroup>
                                            <Input
                                                placeholder="Country"
                                                type="text"
                                                value={selectedInvoice.customer_country || ''}
                                                readOnly
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Label className="form-control-label" md="4">{t('invoice.customer_phone')}</Label>
                                    <Col md="8">
                                        <FormGroup>
                                            <InputGroup>
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>
                                                        {selectedInvoice.country_code || ''}
                                                    </InputGroupText>
                                                </InputGroupAddon>
                                                <Input
                                                    placeholder="Customer Phone"
                                                    type="number"
                                                    value={selectedInvoice.customer_phone || ''}
                                                    required
                                                    readOnly
                                                />
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Label className="form-control-label" md="4">Email</Label>
                                    <Col md="8">
                                        <FormGroup>
                                            <Input
                                                placeholder="Customer Email"
                                                type="text"
                                                value={selectedInvoice.customer_email || ''}
                                                required
                                                readOnly
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Button color="primary" type="submit" disabled={isLoading}>
                                    {isLoading ? (
                                        <>
                                            <Loader className="animate-spin mr-2" size={16} />
                                            {t('invoice.submitting')}
                                        </>
                                    ) : (
                                        t('profile.submit')
                                    )}
                                </Button>
                                <Button color="secondary" onClick={paymentToggleModal} disabled={isLoading}>
                                    {t('profile.cancel')}
                                </Button>
                            </Form>
                        </CardBody>
                    </Card>
                </ModalBody>
            </Modal>


            <Modal className="modal-dialog-centered" size="sm" isOpen={paymentReceiptModal} toggle={receiptToggleModal}>
                <ModalHeader toggle={receiptToggleModal}>{t('invoice.send_receipt')}</ModalHeader>
                <ModalBody>
                    <Card className="bg-secondary border-0 mb-0">
                        <CardBody className="">
                            <div className="text-center text-muted mb-4">
                                {showSuccessAlert && (
                                    <UncontrolledAlert color="success">

                                        <span className="alert-text ml-1">
                                            <strong>{t('profile.success')}</strong>{t('invoice.receipt_sent')}
                                        </span>
                                    </UncontrolledAlert>
                                )}
                                {showErrorAlert && (
                                    <UncontrolledAlert color="danger">
                                        <span className="alert-text ml-1">
                                            <strong>{t('profile.error')}</strong> {t('invoice.receipt_not_sent')}
                                        </span>
                                    </UncontrolledAlert>
                                )}
                            </div>
                            <Form onSubmit={handleReceiptSubmit}>
                                <Row>
                                    <Label className="form-control-label" md="4">{t('invoice.to')}</Label>
                                    <Col md="8">
                                        <FormGroup>
                                            <Input
                                                placeholder="Customer name"
                                                type="text"
                                                value={selectedInvoice.customer_name || ''}
                                                readOnly
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Label className="form-control-label" md="4">Email</Label>
                                    <Col md="8">
                                        <FormGroup>
                                            <Input
                                                placeholder="Customer Address"
                                                type="text"
                                                value={selectedInvoice.customer_email || ''}
                                                required
                                                readOnly
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <div className="text-center">
                                    <Button color="primary" type="submit" disabled={isLoading}>
                                        {isLoading ? (
                                            <>
                                                <Loader className="animate-spin mr-2" size={16} />
                                                {t('invoice.submitting')}
                                            </>
                                        ) : (
                                            t('profile.submit')
                                        )}
                                    </Button>
                                    <Button color="secondary" onClick={receiptToggleModal} disabled={isLoading}>
                                        {t('profile.cancel')}
                                    </Button>
                                </div>
                            </Form>
                        </CardBody>
                    </Card>
                </ModalBody>
            </Modal>
        </>
    );
}

export default Invoice;
